import { interfaces } from "suneditor";
import type { SunEditor } from "suneditor/types";

/**
 * @class
 * @description Plugin for inserting a Habil+ anchor link.
 */
export default class HabilLink extends interfaces.PluginCommand {
    static key = "habilLink";

    constructor(kernel: SunEditor.Kernel) {
        super(kernel);
        this.title = "Habil+ link";
        this.icon = '<span style="font-size:14px;font-weight:bold">H+</span>';
    }

    /** @override @type {PluginCommand['action']} */
    action(): void {
        const { $ } = this;

        // 1. Get the editable element and its document context
        const wysiwyg = $.frameContext.get('wysiwyg') as HTMLElement;
        if (!wysiwyg)
            return;

        const doc = wysiwyg.ownerDocument as Document;

        try {
            // 2. Create the anchor element natively
            const anchor = doc.createElement('a') as HTMLAnchorElement;
            anchor.href = '[@@_MESSAGE_URL_@@]';
            anchor.textContent = 'Habil+';
            anchor.target = '_blank';
            anchor.classList.add('se-custom-link');

            // 3. Get the current range (where the cursor is)
            const range = $.selection.getRange();

            // Delete any highlighted text before inserting
            range.deleteContents();

            // 4. Insert the node
            range.insertNode(anchor);

            // 5. Position the cursor after the new anchor
            // This prevents the user from typing inside the link by accident
            const nextSibling = doc.createTextNode('\u200B'); // Zero-width space
            anchor.parentNode?.insertBefore(nextSibling, anchor.nextSibling);

            $.selection.setRange(nextSibling, 1, nextSibling, 1);
        }
        catch (error) {
            console.error("Anchor insertion failed:", error);
        }
        finally {
            // 6. MANDATORY: Sync with the Undo/Redo history
            if ($.history && typeof $.history.push === 'function') {
                $.history.push(false);
            }
        }
    }
}